import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Form,
  Select,
  Row,
  Col,
  Spin,
  Tooltip,
  Image,
  message
} from "antd";
import {
  PlusOutlined,
  QuestionCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import UserIcon from "../../../../../../assets/images/icons/userLogo.svg";
import { useLocation, useParams } from "react-router-dom";
import { useStore } from "../../../../../../store";
import { aboutUSkeys } from "../../../../../../config";
import { useTab } from "../../../../../../custom-hooks/useTab";
import { useConnectsuForm } from "../../../../../../custom-hooks/useConnectsuForm";
import { getFormFieldValue } from "../../../../../../utils";
import { sortDataByOrder } from "../../../../../../utils/helper"
import ReactPlayer from "react-player/youtube";
import SynthesiaVideo from "../../SynthesiaVideo";
import userServiceApi from "../../../../../../api/userServiceApi";
import reArrangeOrder from "../../../../../common/DragAndDropList/rearrangeHelper";
import {
  DragAndDropList,
  GifCreator,
  GifResultPreview,
  createEmptyGifState,
  hydrateGifCreatorState,
} from "../../../../../../components/common";
import './AboutUs.scss'

const { TextArea } = Input;
const MAX_CHARACTERS = 2000;

const withGifDefaults = (rows) => {
  if (!Array.isArray(rows)) return rows;
  return rows.map((row) => {
    if (row?.mediaLink?.mediaType === "GIF") {
      return {
        ...row,
        mediaLink: {
          ...row.mediaLink,
          gifCreator: hydrateGifCreatorState(row.mediaLink),
        },
      };
    }
    return row;
  });
};

const rowHasUnsavedData = (item) => {
  const mediaLink = item?.mediaLink;
  const mediaUrl =
    typeof mediaLink === "string"
      ? mediaLink.trim()
      : mediaLink?.url?.trim?.() || "";

  return !!(
    item?.title?.trim() ||
    item?.description?.trim() ||
    mediaUrl ||
    item?.media ||
    mediaLink?.gifCreator?.images?.length ||
    mediaLink?.gifCreator?.generatedFile ||
    mediaLink?.gifCreator?.previewUrl
  );
};

export default function OurStoryComponent({
  dataLoader,
  form,
  activeKey,
}) {
  const { state } = useLocation();
  const tabKey = state;

  const { tabData } = useStore();
  const tabConfigId = localStorage.getItem("selectedTabId");
  const { micrositeId } = useParams();
  const whichTab = aboutUSkeys["Our Story"];
  const { deleteSingleItem, postLoader } = useTab();
  const { updateImage } = useConnectsuForm();
  const [loader, setLoader] = useState(true);
  const [formChanged, setFormChanged] = useState(false);
  const { updatedValues } = useStore();
  const [canAddNew, setCanAddNew] = useState(true);
  const [hasUnsavedItem, setHasUnsavedItem] = useState(false);

  if (activeKey === "OUR_STORY") {
    localStorage.setItem("tab", activeKey);
  }

  useEffect(() => {
    setFormChanged(false);
    setCanAddNew(true);
  }, []);

  useEffect(() => {
    const isNotEmpty = Object.keys(updatedValues).length > 0;
    setFormChanged(isNotEmpty);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(updatedValues).length]);


  const renderMedia = (dataItem, rowIndex) => {
    const commonStyles = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    };

    const mediaType = dataItem?.mediaLink?.mediaType;
    const mediaUrl =
      dataItem?.mediaLink?.url || // 👈 form state
      dataItem?.aboutUsTeamDataOutPut?.image?.url; // 👈 backend fallback

    if (mediaType === "GIF") {
      const gifState = dataItem.mediaLink.gifCreator || {};
      const gifUrl = gifState.previewUrl || mediaUrl;
      return (
        <GifResultPreview
          url={gifUrl}
          fileName={gifState.fileName}
          loading={!!gifState.generating}
          showEdit={!!gifUrl && gifState.isEditing === false}
          onEdit={() => {
            const current = form.getFieldValue([
              whichTab,
              rowIndex,
              "mediaLink",
              "gifCreator",
            ]);
            form.setFieldValue(
              [whichTab, rowIndex, "mediaLink", "gifCreator"],
              { ...createEmptyGifState(), ...current, isEditing: true }
            );
          }}
        />
      );
    }

    if (!mediaUrl) return null;

    if (mediaType === "SOCIAL_MEDIA") {
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <ReactPlayer
            controls={true}
            url={mediaUrl}
            width="100%"
            height="100%"
          />
        </div>
      );
    } else if (mediaType === "VIMEO_MEDIA") {
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <iframe
            title="Embedded video"
            src={mediaUrl}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            style={{ width: "100%", height: "100%", backgroundColor: "black" }}
          />
        </div>
      );
    } else if (mediaType === "IMAGE" || !mediaType) {
      // default/fallback: IMAGE or no type provided
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <img
            src={mediaUrl}
            alt="media"
            className="c1 carousel-image"
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        </div>
      );
    }
    else if (
      dataItem?.mediaLink?.mediaType === "SYNTHESIA_MEDIA" &&
      dataItem.mediaLink.url) {
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <SynthesiaVideo key={dataItem.id} videoData={dataItem} />

        </div>
      )
    }


    return null;
  };


  const findValue = (i, key) => {
    return getFormFieldValue(form, whichTab, i, key);
  };


  const SelectChangeHandler = (e, i) => {
    form.setFieldValue([whichTab, i, "mediaLink", "url"], "");
    if (e === "GIF") {
      form.setFieldValue(
        [whichTab, i, "mediaLink", "gifCreator"],
        createEmptyGifState()
      );
    } else {
      form.setFieldValue([whichTab, i, "mediaLink", "gifCreator"], undefined);
    }
  };


  const handleAddMore = () => {
    if (!canAddNew) {
      message.warning("Please save or clear the current item before adding a new one.");
      return;
    }

    const currentList = form.getFieldValue(whichTab) || [];

    const unsavedItem = currentList.find((item) => {
      const hasData =
        item?.title?.trim() ||
        item?.description?.trim() ||
        item?.mediaLink?.url ||
        item?.media ||
        item?.mediaLink?.gifCreator?.images?.length ||
        item?.mediaLink?.gifCreator?.generatedFile;
      return !item?.id && hasData;
    });

    if (unsavedItem) {
      message.warning("Please save or clear the current item before adding a new one.");
      return;
    }

    // ✅ Prepend new empty row at the top (aligned with your fields)
    const newList = [
      {
        title: "",
        bio: "",
        linkedin: "",
        email: "",
        mediaLink: { mediaType: undefined, url: "", gifCreator: undefined },
        media: null,
      },
      ...currentList,
    ];

    form.setFieldsValue({ [whichTab]: newList });

    setCanAddNew(false);
    setHasUnsavedItem(true);

    // Scroll to top to focus on the newly added row
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSave = async() => {
    await form.submit();
    setCanAddNew(true);
    setHasUnsavedItem(false);
  };

  const refreshUnsavedState = () => {
    const currentList = form.getFieldValue(whichTab) || [];
    const unsavedItem = currentList.find(
      (item) => !item?.id && rowHasUnsavedData(item)
    );
    setCanAddNew(!unsavedItem);
  };

  const handleClear = (fields, remove) => {
    const currentList = form.getFieldValue(whichTab) || [];

    // 1️⃣ Remove newly added unsaved rows except the first
    const itemsToRemove = [];
    fields.forEach((f, i) => {
      if (!findValue(i, "id") && i !== 0) {
        itemsToRemove.push(f.name);
      }
    });
    if (itemsToRemove.length > 0) {
      remove(itemsToRemove);
    }

    // 2️⃣ Reset first unsaved row fields if any
    if (currentList.length > 0) {
      const updatedList = [...currentList];
      const clearIndex = updatedList.findIndex((item) => !item?.id);

      if (clearIndex !== -1) {
        updatedList[clearIndex] = {
          title: "",
          description: "",
          mediaLink: { mediaType: undefined, url: "", gifCreator: undefined },
          media: null,
        };
      }

      form.setFieldsValue({ [whichTab]: updatedList });
    }

    // 3️⃣ Safe unsaved check (no trim errors)
    const unsavedItem = (form.getFieldValue(whichTab) || []).find((item) => {
      const title = typeof item?.title === "string" ? item.title.trim() : "";
      const desc = typeof item?.description === "string" ? item.description.trim() : "";
      const url = typeof item?.mediaLink?.url === "string" ? item.mediaLink.url.trim() : "";

      return !item?.id && (title || desc || url);
    });

    setCanAddNew(!unsavedItem);
  };


  useEffect(() => {
    const timer = setTimeout(() => {
      const ourClientEmpty = tabData?.OUR_CLIENT?.length === 0;
      const ourStoryEmpty = tabData?.OUR_STORY?.length === 0;
      const ourSupportersEmpty = tabData?.OUR_SUPPORTERS?.length === 0;

      if (ourClientEmpty || ourStoryEmpty || ourSupportersEmpty) {
        setHasUnsavedItem(true);
      } else {
        setHasUnsavedItem(false);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [tabData?.OUR_CLIENT, tabData?.OUR_STORY, tabData?.OUR_SUPPORTERS]);


  const handleDelete = (whichTab, form, i, name, remove) => {

    const item = form.getFieldValue(whichTab)?.[i];
    const id = item?.id;

    if (id) {
      // Backend delete
      deleteSingleItem(whichTab, id, form);
    } else {
      // UI-only delete (new row not yet saved)
      remove(name);
      setHasUnsavedItem(false);
      refreshUnsavedState();
    }

    // Optional state updates (only if you need them)
    setTimeout(() => {
      const currentList = form.getFieldValue(whichTab) || [];
      const unsavedItem = currentList.find(
        (it) =>
          !it?.id &&
          (it?.title?.trim() || it?.description?.trim())
      );

      setCanAddNew(!unsavedItem);
      setHasUnsavedItem(!!unsavedItem);
      refreshUnsavedState();
    }, 100);
  };

  useEffect(() => {
    form.resetFields();
    if (tabData && tabData[whichTab] && tabData[whichTab].length > 0) {
      form.setFieldsValue({
        [whichTab]: withGifDefaults(sortDataByOrder(tabData[whichTab])),
      });
    }
    refreshUnsavedState();
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabData[whichTab]]);

  if (dataLoader || postLoader || loader) {
    return (
      <div className="data-loader">
        <Spin tip="Loading" size="large" />
      </div>
    );
  } else {
    return (
      <div className="newContantStyle">
        <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          {tabKey.split("/")[1] === whichTab ? (
            <>
              <Col className="gutter-row tabContent" span={24}>
                <Form.List
                  name={whichTab}
                  initialValue={
                    tabData &&
                      tabData[whichTab] &&
                      tabData[whichTab].length > 0
                      ? withGifDefaults(sortDataByOrder(tabData[whichTab]))
                      : [""]
                  }
                >
                  {(fields, { add, remove, move }) => {
                  return(
                    <>
                      <Col
                        className="gutter-row tabContent"
                        xs={24}
                        sm={24}
                        md={14}
                        lg={14}
                        style={{ paddingRight: "25px" }}
                      >
                        <div className="inputBody">
                          <div style={{ textAlign: "right" }}>
                            {hasUnsavedItem && (
                              <Button
                                className="cancelBtn"
                                type="button"
                                onClick={() => handleClear(fields, remove)} // ✅ fixed
                              >
                                Clear
                              </Button>
                            )}
                            <Button
                              className="greenBtn"
                              onClick={handleAddMore}
                            >
                              Add <PlusOutlined />
                            </Button>
                          </div>
                        </div>
                      </Col>

                      <Col
                        className="gutter-row tabContent"
                        xs={24}
                        sm={24}
                        md={10}
                        lg={10}
                      >
                      </Col>
                      <DragAndDropList
                        fields={fields}
                        move={move}
                        form={form}
                        fieldName={whichTab}
                        onReorder={(payload) => reArrangeOrder(
                          userServiceApi.reArrangeDataInAboutUs({
                            tabConfigId,
                            micrositeId,
                            aboutUsEnum: "OUR_STORY",
                          }),
                          payload
                        )}
                        renderItem={({ key, name, ...restField }, i) => (
                          <div className="card-item">
                            <Col
                              className="gutter-row tabContent"
                              xs={24}
                              sm={24}
                              md={14}
                              lg={14}
                              style={{ paddingRight: "25px" }}
                            >
                              <div className="d-flex">
                                <Form.Item
                                  className="w-100"
                                  {...restField}
                                  label="Name/Title"
                                  name={[name, "title"]}
                                  labelCol={{ span: 5 }}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Title is required",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="Enter Title"
                                    maxLength={40}
                                    showCount={{
                                      formatter: ({ count }) => `${count}/40`,
                                    }}
                                    onKeyDown={(e) => {
                                      const currentValue = form.getFieldValue([whichTab, name, "title"]) || "";

                                      // Ignore control keys
                                      if (
                                        e.key.length === 1 && // only normal characters
                                        currentValue.length >= 40
                                      ) {
                                        form.setFields([
                                          {
                                            name: [whichTab, name, "title"],
                                            errors: ["Title cannot exceed 40 characters"],
                                          },
                                        ]);
                                      }
                                    }}
                                    onBlur={() => {
                                      form.setFields([
                                        {
                                          name: [whichTab, name, "title"],
                                          errors: [],
                                        },
                                      ]);
                                    }}
                                  />
                                </Form.Item>

                                <Form.Item>
                                  <div className="remove-btn">
                                    <DeleteOutlined
                                      style={{ cursor: "pointer" }}
                                      title="Delete Team"
                                      onClick={() => {
                                        handleDelete(
                                          whichTab,
                                          form,
                                          i,
                                          name,
                                          remove
                                        );
                                      }}
                                    />
                                  </div>
                                </Form.Item>
                              </div>

                              <div className="d-flex">
                                <Form.Item
                                  label="Description"
                                  {...restField}
                                  labelCol={{ span: 5 }}
                                  name={[name, "description"]}
                                  className="w-100"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Description is required",
                                    },
                                    {
                                      max: MAX_CHARACTERS - 1,
                                      message: `Description should be less than ${MAX_CHARACTERS} character`,
                                    },
                                  ]}
                                >
                                  <TextArea
                                    placeholder="Enter Description"
                                    rows={5}
                                    maxLength={MAX_CHARACTERS}
                                    showCount
                                    style={{ whiteSpace: "pre-wrap" }}
                                  />
                                </Form.Item>
                              </div>

                              <div className="d-flex">
                                <Form.Item
                                  {...restField}
                                  className="custom-work"
                                  name={[name, "mediaLink", "mediaType"]}
                                  label="Video or Image"
                                  labelCol={{ span: 5 }}
                                >
                                  <Select
                                    name={[name, "mediaLink", "mediaType"]}
                                    onChange={(e) =>
                                      SelectChangeHandler(e, i)
                                    }
                                    placeholder="Select Option"
                                  >
                                    <Select.Option value="VIMEO_MEDIA">
                                      Add Vimeo Link
                                    </Select.Option>
                                    <Select.Option value="SOCIAL_MEDIA">
                                      Add Youtube Link
                                    </Select.Option>
                                    <Select.Option value="SYNTHESIA_MEDIA">
                                      Add Synthesia Link
                                    </Select.Option>

                                    <Select.Option value="IMAGE">
                                      Upload Image
                                    </Select.Option>
                                    <Select.Option value="GIF">
                                      Create GIF
                                    </Select.Option>
                                  </Select>
                                </Form.Item>
                                <Form.Item>
                                  <div className="remove-btn">
                                    <Tooltip
                                      title={
                                        "Upload Video link or image with size lesser than 2.5MB. For best results, use images and videos with a 16:9 aspect ratio"
                                      }
                                    >
                                      <QuestionCircleOutlined />
                                    </Tooltip>
                                  </div>
                                </Form.Item>
                              </div>
                              {findValue(i, "type") === "SOCIAL_MEDIA" ? (
                                <Form.Item
                                  label="Youtube Link"
                                  labelCol={{ span: 5 }}
                                  {...restField}
                                  name={[name, "mediaLink", "url"]}
                                >
                                  <Input />
                                </Form.Item>
                              ) : findValue(i, "type") === "VIMEO_MEDIA" ? (
                                <Form.Item
                                  label="Vimeo Link"
                                  labelCol={{ span: 5 }}
                                  {...restField}
                                  name={[name, "mediaLink", "url"]}
                                >
                                  <Input />
                                </Form.Item>
                              ) : findValue(i, "type") === "IMAGE" ? (
                                <Form.Item
                                  {...restField}
                                  label="Image"
                                  colon={false}
                                  name="media"
                                  className="experienceImg uploadedImage"
                                  labelCol={{ span: 5 }}
                                >
                                  {findValue(i, "blob") ? (
                                    <Image
                                      src={URL.createObjectURL(
                                        findValue(i, "blob")
                                      )}
                                      alt=""
                                    />
                                  ) : findValue(i, "url") ? (
                                    <Image
                                      src={findValue(i, "url")}
                                      alt=""
                                    />
                                  ) : (
                                    <Image src={UserIcon} alt="" />
                                  )}
                                  <div>
                                    <div style={{
                                      display: 'flex',
                                      alignItems: 'center'
                                    }}>
                                      <label
                                        name="file"
                                        className="fileUploadBtn greenBtn"
                                      >
                                        {" "}
                                        Upload image
                                        <input
                                          accept="image/png, image/gif, image/jpeg"
                                          type="file"
                                          // required={true}
                                          onChange={(e) =>
                                            updateImage(e, i, form, whichTab)
                                          }
                                        />

                                      </label>
                                      <Tooltip
                                        className="question"
                                        title={"Recommended image dimensions: 1280x720 pixels"}
                                      >
                                        <QuestionCircleOutlined />
                                      </Tooltip>
                                    </div>
                                    <div style={{ marginLeft: '12px', marginTop: '5px' }} className="">Add or Edit</div>
                                  </div>
                                </Form.Item>
                              ) : findValue(i, "type") === "GIF" ? (
                                <Form.Item
                                  {...restField}
                                  label="Create GIF"
                                  colon={false}
                                  name={[name, "mediaLink", "gifCreator"]}
                                  className="gif-creator-field"
                                  labelCol={{ span: 5 }}
                                  initialValue={createEmptyGifState()}
                                >
                                  <GifCreator />
                                </Form.Item>
                              ) : findValue(i, "type") ===
                                "SYNTHESIA_MEDIA" ? (
                                <Form.Item
                                  label="Synthesia Link"
                                  labelCol={{ span: 5 }}
                                  {...restField}
                                  name={[name, "mediaLink", "url"]}

                                >
                                  <Input />
                                </Form.Item>
                              ) : null}

                              <Form.Item
                                className="w-100"
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                {formChanged ? (
                                  <Button
                                    className="saveBtn greenBtn"
                                    onClick={handleSave}
                                  >
                                    Save
                                  </Button>
                                ) : (
                                  <Button
                                    className="saveBtn greenBtn"
                                    style={{
                                      opacity: "0.5",
                                      pointerEvents: "none",
                                    }}
                                  >
                                    Save
                                  </Button>
                                )}
                              </Form.Item>
                            </Col>
                            <Col
                              className="gutter-row tabContent"
                              xs={24}
                              sm={24}
                              md={10}
                              lg={10}
                            >
                              <Form.Item shouldUpdate noStyle>
                                {() => {
                                  const row = form.getFieldValue(whichTab)?.[i];
                                  if (!row) return null;
                                  return (
                                    <div className="gif-container">
                                      {renderMedia(row, i)}
                                    </div>
                                  );
                                }}
                              </Form.Item>
                            </Col>
                          </div>
                        )}
                      />
                    </>
                  )
                  }}
                </Form.List>
              </Col>
            </>
          ) : (
            <></>
          )}
        </Row>
      </div>
    );
  }
}
